import useBoolean from '@eduzz/houston-hooks/useBoolean';
import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import Modal from 'v2/components/Shared/Modal';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { useStyles } from './styles';

const ModalOwnership = memo(() => {
  const classes = useStyles();
  const history = useHistory();

  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [open, toggle] = useBoolean(false);

  function onClose() {
    toggle();
  }

  function onProceed() {
    history.push('/producer/profile/bankdata');
  }

  React.useEffect(() => {
    !!user?.show_account_owner_change_modal && toggle();
  }, [toggle, user]);

  return (
    <Modal
      size='xs'
      open={open}
      setClose={onClose}
      textTitle='Atenção'
      textReturnButton=''
      textProceedButton='Ir para Dados Bancários'
      handleProceedClick={onProceed}
    >
      <p className={classes.paragraph}>
        Após a troca de titularidade, as contas bancárias serão <strong>canceladas</strong> para a sua segurança.
      </p>
      <p className={classes.paragraph}>
        Você pode cadastrar sua nova conta bancária de forma <strong>simples e rápida</strong>, basta clicar em{' '}
        <strong>Ir para Dados bancários</strong> e depois em <strong>Cadastrar nova conta</strong>.
      </p>
      <p className={classes.paragraph}>Qualquer dúvida, entre em contato com o nosso suporte. Estamos à disposição!</p>
    </Modal>
  );
});

export default ModalOwnership;
